export default "__VITE_ASSET__C4Bd7Rd$__"